KROWN.themeName = 'Kingdom';
KROWN.themeVersion = '5.1.7';

// Shopify events

const executeOnceOnDomContentLoaded = () => {
  document.querySelectorAll('input').forEach(elm => {
    elm.addEventListener('change', e => {
      if (e.target.value != '') {
        elm.classList.add('filled');
      } else {
        elm.classList.remove('filled');
      }
    });
  });

  document.querySelectorAll('input[type="search"]').forEach(elm => {
    elm.value = '';
  });

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e => {
    if (e.keyCode === window.KEYCODES.TAB) {
      if (activeElement.classList.contains('focus') && e.target !== activeElement) {
        activeElement.classList.remove('focus');
      }
      if (
        e.target.classList.contains('regular-select-cover') ||
        e.target.classList.contains('search-field') ||
        e.target.classList.contains('product-item__link') ||
        e.target.classList.contains('content-slider') ||
        e.target.classList.contains('blog-item__header') ||
        e.target.classList.contains('toggle__title') ||
        e.target.tagName === 'INPUT'
      ) {
        activeElement = e.target;
        e.target.classList.add('focus');
      }
    }
  });

  if (window.location.search === '?customer_posted=true') {
    setTimeout(() => {
      const alert = document.querySelector('form .alert');
      if (alert) {
        window.scroll({
          top: alert.offsetTop - 250,
          behavior: 'smooth'
        });
      }
    }, 300);
  } else if (window.location.pathname.includes('/challenge')) {
    setTimeout(() => {
      window.scroll({
        top: 0,
        behavior: 'auto'
      });
    }, 300);
  }

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => updateShippingNoticeAjax(cart));
};

if (document.readyState !== 'loading') {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}


function updateShippingNoticeAjax(cart) {
  const threshold = 4000;
  const noticeEl = document.getElementById('free-shipping-notice');
  const barEl = document.getElementById('free-shipping-bar');
  if (!noticeEl) return;

  const progress = Math.min((cart.total_price / threshold) * 100, 100);

  if (cart.total_price >= threshold) {
    noticeEl.textContent = "🎉 Du erhältst kostenlosen Versand!";
    noticeEl.style.color = "green";
  } else {
    const missing = ((threshold - cart.total_price) / 100).toFixed(2).replace('.', ',');
    noticeEl.textContent = `📦 Noch ${missing} € bis zum kostenlosen Versand!`;
    noticeEl.style.color = "#fd7074";
  }

  if (barEl) {
    barEl.style.width = progress + '%';
    barEl.style.backgroundColor = cart.total_price >= threshold ? "green" : "#fd7074";
  }
}

if (!window.refreshCart) {
  window.refreshCart = () => {
    fetch('?section_id=cart-helper')
      .then(response => {
        if (!response.ok) throw new Error('Fehlerhafte Antwort vom Server');
        return response.text();
      })
      .then(text => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const newCartForm = sectionInnerHTML.getElementById('AjaxCartForm');
        const newSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');

        if (!newCartForm || !newSubtotal) return;

        const cartItems = document.getElementById('AjaxCartForm');
        const subtotalEl = document.getElementById('AjaxCartSubtotal');

        cartItems.innerHTML = newCartForm.innerHTML;
        subtotalEl.innerHTML = newSubtotal.innerHTML;

        if (typeof cartItems.ajaxifyCartItems === 'function') {
          cartItems.ajaxifyCartItems();
        }

        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const headerCartCount = document.querySelector('[data-header-cart-count]');
            if (headerCartCount) {
              headerCartCount.textContent = cart.item_count;
              headerCartCount.classList.add('cart-bounce');
              setTimeout(() => {
                headerCartCount.classList.remove('cart-bounce');
              }, 400);
            }

            updateShippingNoticeAjax(cart);
          });

        const drawer = document.querySelector('.sidebar__cart');
        if (drawer && typeof drawer.show === 'function') {
          drawer.show();
        }

        const errorMsg = document.querySelector('.form-message--error');
        if (errorMsg) {
          errorMsg.remove();
        }
      })
      .catch(err => {
        console.error('Fehler beim Aktualisieren des Ajax-Warenkorbs:', err);
        alert('Es gab einen Fehler. Bitte lade die Seite neu.');
      });
  };
}

document.addEventListener('input', function (e) {
  if (
    e.target.name === 'updates[]' &&
    e.target.closest('#AjaxCartForm')
  ) {
    const input = e.target;
    const quantity = parseInt(input.value);
    const itemContainer = input.closest('.cart-item');
    const lineItemKey = itemContainer?.getAttribute('data-id');

    if (!lineItemKey || isNaN(quantity)) return;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: quantity
      })
    })
      .then(response => {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(() => {
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        }
      })
      .catch(err => {
        console.error('Fehler bei cart/change.js:', err);
        alert('Es gab einen Fehler beim Aktualisieren des Warenkorbs.');
      });
  }
});

if (window.location.pathname === '/cart') {
  document.addEventListener('change', function (e) {
    if (e.target.name === 'updates[]') {
      const form = document.getElementById('cart');
      if (!form) return;

      const formData = new FormData(form);

      fetch('/cart/update.js', {
        method: 'POST',
        body: formData
      })
        .then(res => {
          if (!res.ok) throw new Error('Update failed');
          return res.json();
        })
        .then(cart => {
          updateShippingNoticeAjax(cart);
          location.reload();
        })
        .catch(() => {
          alert('Es gab einen Fehler. Bitte versuch es erneut.');
        });
    }
  });
}

document.addEventListener('click', function (e) {
  if (
    e.target.matches('[data-ajax-cart-quantity]') ||
    e.target.closest('[data-ajax-cart-quantity]') ||
    e.target.closest('.remove')
  ) {
    setTimeout(() => {
      if (typeof window.refreshCart === 'function') {
        window.refreshCart();
      }
    }, 300);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');

  forms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);
      const button = form.querySelector('[name="add"]');
      const textElement = button.querySelector('[data-js-product-add-to-cart-text]');
      const originalText = textElement ? textElement.innerText : null;

      if (button) {
        button.classList.add('loading');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(res => {
          if (!res.ok) throw new Error('Fehler beim Hinzufügen');
          return res.json();
        })
        .then(item => {
          if (typeof window.refreshCart === 'function') {
            window.refreshCart();
          }

          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const headerCartCount = document.querySelector('[data-header-cart-count]');
              if (headerCartCount) {
                headerCartCount.textContent = cart.item_count;
              }
            });
        })
        .catch(err => {
          alert('Leider konnte das Produkt nicht hinzugefügt werden.');
          console.error(err);
        })
        .finally(() => {
          if (button) {
            button.classList.remove('loading');
            if (textElement && originalText) {
              textElement.innerText = originalText;
            }
          }
        });
    });
  });
});